<template>
  <div>

    <form @submit.prevent="submit">
      <p class="text-muted">Informe qual será sua nova senha</p>

      <div class="form-group">
        <input type="password" class="form-control form-control-xl bg-light-2 border-0" placeholder="Senha" required v-b-tooltip.focus="'Sua senha deve ter no mínimo 8 caracteres'" v-model="password" @blur="passwordConfirm.length > 0 && checkPasswordConfirm()">
      </div>

      <div class="form-group">
        <input type="password" class="form-control form-control-xl bg-light-2 border-0" placeholder="Repita sua senha" required v-model="passwordConfirm" @blur="checkPasswordConfirm">
        <small class="form-text text-danger" v-if="passwordConfirmMessage">{{ passwordConfirmMessage }}</small>
      </div>

      <div class="text-center">
        <button type="submit" class="btn btn-wl-secondary btn-block" :disabled="!disabledForm">Salvar nova senha</button>
      </div>
    </form>

  </div>
</template>

<script>
  export default {
    name: 'ChangePasswordForm',

    data(){
      return {
        password: '',
        passwordConfirm: '',
        passwordConfirmMessage: null,
        token: this.$route.query.token
      }
    },

    computed: {
      disabledForm(){
        return this.$helpers.validPassword(this.password) && this.password == this.passwordConfirm
      }
    },

    methods: {
      checkPasswordConfirm(){
        this.passwordConfirmMessage = this.password == this.passwordConfirm ? null : 'Senhas diferentes';
      },

      submit(){
        let params = {};
        params.password = this.password

        // Quando existe token, é uma recuperação de senha por meio do Esqueci minha Senha
        if( this.token ){
          params.token = this.token
        }else{

          params.user_id = this.$route.query.user_id || this.$store.state.user.profile.id

        }

        this.$store.dispatch('user/changePassword', params).then( response => {

          if( response.error ){
            this.$swal("Uoops", 'Algo errado aconteceu. Tente novamente.', "error")
          }else{

            /**
             * Se não houver nenhum erro no retorno do changePassword, verificamos se existe token
             * Quando existe token, é uma recuperação de senha por meio do Esqueci minha Senha, logo existe
             * a necessidade de logar o usuário
             *
             * Quando não existir token, é uma alteração de senha simples e só damos o feedback para o usuário
             */
            if( this.token ){
              let current_profile = this.$store.state.deviseTrying;
              current_profile.email = response.data.changePassword.email;
              current_profile.password = this.password;
              current_profile.keepLogged = false;
              current_profile.provider = null;
              current_profile.id = null;
              this.$store.commit('DEVISE_TRYING', current_profile);

              this.$swal({
                title: '',
                text: 'Senha alterada com sucesso!',
                type: 'success',
                showCancelButton: false,
                confirmButtonText: 'Fechar'
              }).then((result) => {
                if (result.value) {
                  this.$emit('signIn');
                }
              })
            }
            else{

              if(this.$route.query.user_id){

                let current_profile = this.$store.state.deviseTrying;
                current_profile.email = this.$route.query.email;
                current_profile.password = this.password;
                current_profile.keepLogged = false;
                current_profile.provider = null;
                current_profile.id = null;
                this.$store.commit('DEVISE_LOADING', true)
                this.$store.dispatch('user/signIn', current_profile).then( response => {
                  if(response.error){
                    this.$swal('Uoops', 'E-mail ou senha incorretos', 'error');
                    this.$store.commit('DEVISE_LOADING', false)
                  }else{
                    location.href = '/meu-perfil'
                  }
                })
              }else{
                this.$swal({
                  title: '',
                  text: 'Senha alterada com sucesso!',
                  type: 'success',
                  showCancelButton: false,
                  confirmButtonText: 'Fechar'
                }).then((result) => {
                  if (result.value) {
                    this.$store.commit('DEVISE_FORM', null);
                  }
                })
              }

            }

          }
        })
      }

    }
  }
</script>

<style lang="scss"></style>